import { useEffect, useMemo } from "react";
import * as THREE from "three";

function DwgLayer({
  layers,
  uniformScale,
  position = [0, 0, 0],
  bufferRatio = 0.05,
  realWidth,
  realHeight,
  scaleFactor,
  grid,
  visualGrid,
  originOffsetX = 0,
  originOffsetY = 0,
  renderOrderBase = 200,
}) {
  // Build the DWG group whenever layers or scale change
  const dwgGroup = useMemo(() => {
    if (!Array.isArray(layers) || layers.length === 0) return null;

    const mainGroup = new THREE.Group();

    layers.forEach((layer) => {
      if (!layer?.objects?.length) return;

      const layerGroup = new THREE.Group();

      layer.objects.forEach((obj) => {
        const geometry = obj?.geometry;
        if (!geometry?.attributes?.position) return;

        if (obj.isLineSegments || obj.isLine) {
          const geom = geometry.clone();
          geom.computeBoundingBox();

          const material = new THREE.LineBasicMaterial({
            color: 0xD3D3D3,
            linewidth: 1,
            depthTest: true,
            depthWrite: false,
          });

          const line = new THREE.LineSegments(geom, material);
          line.rotation.x = -Math.PI / 2;
          line.renderOrder = renderOrderBase;
          layerGroup.add(line);
        }
      });

      if (layerGroup.children.length > 0) mainGroup.add(layerGroup);
    });

    if (mainGroup.children.length === 0) return null;

    // Scale
    mainGroup.scale.set(uniformScale, uniformScale, uniformScale);
    mainGroup.updateMatrixWorld(true);

    mainGroup.position.set(
      -originOffsetX,
      0,
      originOffsetY
    );

    return mainGroup;
  }, [layers, uniformScale, realWidth, realHeight, originOffsetX, originOffsetY, renderOrderBase]);

  if (!dwgGroup) return null;

  return <primitive object={dwgGroup} position={dwgGroup.position} />;
}

export default DwgLayer;
